import React from "react";
import { msTeamsMeetingRolesEnum } from "../enum/msTeamsMeetingRolesEnum";
import { UserStatus } from "../service/InMeetingAppService";
import { Text } from "@fluentui/react-components";
import {
    VideoRegular,
    PersonCircleRegular,
    ShareRegular,
    LinkRegular,
    VideoOffRegular,
    CloudRegular,
} from "@fluentui/react-icons";
import styles from "../styles/inMeetingApp.module.scss";
import { useTranslation } from "../../shared/translation/Translation";

export interface BeforeMeetingProps {
    role: msTeamsMeetingRolesEnum;
    userStatus: UserStatus;
}

const BeforeMeeting: React.FC<BeforeMeetingProps> = (props) => {
    const messages = useTranslation();

    const renderOrganizerView = () => {
        return (
            <div className={styles.viewContainer}>
                <div>
                    <h2>{messages.beforeMeeting.header}</h2>
                    <p>{messages.beforeMeeting.organizatorSubHeader}</p>
                </div>
                <h3>{messages.beforeMeeting.rulesHeader}</h3>
                <div className={styles.iconRow}>
                    <VideoRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.organizerRules.recordRule}</Text>
                </div>
                <div className={styles.iconRow}>
                    <PersonCircleRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.setBackgroundRule}</Text>
                </div>
                <h3>
                    <strong>{messages.beforeMeeting.rememberHeader}</strong>
                    {messages.beforeMeeting.meetingRules.header}
                </h3>
                <div className={styles.iconRow}>
                    <ShareRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.meetingRules.noDesktopSharingRule}</Text>
                </div>
                <div className={styles.iconRow}>
                    <LinkRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.meetingRules.noLinksOpenRule}</Text>
                </div>
                <div className={styles.iconRow}>
                    <VideoOffRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.organizerRules.alwaysRecordRule}</Text>
                </div>
                {!props.userStatus.hasEnoughOneDriveSpaceToRecord && (
                    <>
                        <h3>
                            <strong>{messages.beforeMeeting.cautionHeader}</strong>
                        </h3>
                        <div className={styles.iconRow}>
                            <CloudRegular style={{ fontSize: "24px" }} />
                            <Text weight="semibold">{messages.beforeMeeting.notEnoughDiskSpace}</Text>
                        </div>
                    </>
                )}
            </div>
        );
    };

    const renderPresenterView = () => {
        return (
            <div className={styles.viewContainer}>
                <div>
                    <h2>{messages.beforeMeeting.header}</h2>
                    <p>{messages.beforeMeeting.presenterSubHeader}</p>
                </div>
                <h3>{messages.beforeMeeting.rulesHeader}</h3>
                <div className={styles.iconRow}>
                    <PersonCircleRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.setBackgroundRule}</Text>
                </div>
                <h3>
                    <strong>{messages.beforeMeeting.rememberHeader}</strong>
                    {messages.beforeMeeting.meetingRules.header}
                </h3>
                <div className={styles.iconRow}>
                    <ShareRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.meetingRules.noDesktopSharingRule}</Text>
                </div>
                <div className={styles.iconRow}>
                    <LinkRegular style={{ fontSize: "24px" }} />
                    <Text>{messages.beforeMeeting.meetingRules.noLinksOpenRule}</Text>
                </div>
            </div>
        );
    };

    const renderContent = () => {
        switch (props.role) {
            case msTeamsMeetingRolesEnum.organizer:
                return renderOrganizerView();
            case msTeamsMeetingRolesEnum.presenter:
                return renderPresenterView();
            default:
                return null;
        }
    };

    return <div className={styles.beforeMeetingWrapper}>{renderContent()}</div>;
};

export default BeforeMeeting;
